var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuestionnaire = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.187,
    height: 70.208,
    viewBox: "0 0 63.187 70.208",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_assignment_turned_in_24px",
    d: "M59.166,8.021H44.493a10.489,10.489,0,0,0-19.8,0H10.021A7.041,7.041,0,0,0,3,15.042V64.187a7.041,7.041,0,0,0,7.021,7.021H59.166a7.041,7.041,0,0,0,7.021-7.021V15.042A7.041,7.041,0,0,0,59.166,8.021Zm-24.573,0a3.51,3.51,0,1,1-3.51,3.51A3.521,3.521,0,0,1,34.594,8.021ZM27.573,57.166,13.531,43.125l4.95-4.95,9.092,9.057L50.706,24.1l4.95,4.985Z",
    transform: "translate(-3 -1)",
    fill: "#e3e3e3"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionnaire);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Questionnaire.dc463073cc797be0a2aa324d07d1691a.svg";